import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_GF_API_ENDPOINT
  },
} = getConfig();

/**
 * Helper to access Glowforge API endpoints
 * @param {String} route Glowforge API route. Should have leading slash.
 * @param {Object} options Options to pass to fetch. See fetch spec for
 *                         more details. https://github.com/github/fetch
 */
export default function fetchApi(route, options = {}) {
  return fetch(`${GF_DOTCOM_GF_API_ENDPOINT}${route}`, {
    credentials: 'include',
    ...options,
  });
}
